
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SizeAndPrice, VirtualMachine } from '@/models/VirtualMachine';
import { Helper, WorkspaceDetailsParams } from '@/models/HelperClasses';
import SizeAndPriceTable from '../shared/SizeAndPriceTable.vue';
import VatWarning from "../shared/VatWarning.vue"
import { ajaxGet } from '@/data/ajax';
import { Budget } from "@/models/Budget";
import { mapState } from 'vuex';

@Component({
    components: {SizeAndPriceTable, VatWarning},
    computed: mapState(["sizeAndPrices"])
})
export default class VirtualMachineView extends Vue {
    @Prop({ required: true}) private virtualMachine!: VirtualMachine;
    @Prop({ required: true}) private isOwner!: boolean;
    @Prop({ required: false}) private workspaceIsDisabled!: boolean;
    @Prop()private index!:number;
    @Prop({required: true}) showRemoveVM!: boolean;
    @Prop({required: true}) private budget:Budget;
    @Prop({required: true}) private currentWorkspaceCostPerDay: number;

    public vm: VirtualMachine;
    private showResizeInfo: boolean = false;
    public selectedSize!: SizeAndPrice;
    private passwordIsLoading: boolean = false;
    private selectedSizeAndPrice: SizeAndPrice = null;
    private futureDaysOfBudgetRemaining: number;

    log(...args: any[]) {
        this.vm.log("(view): ", ...args);
    }
    created(){
        this.vm = this.virtualMachine;
    }

    @Watch("sizeAndPrices")
    sizeAndPricesChanged(value: SizeAndPrice[]){
        var model = this;
        if(this.vm && !this.vm.currentSizeAndPrice){
            this.log("currentSizeAndPrice changed")
            this.vm.currentSizeAndPrice = value.find((s: SizeAndPrice) => s.technicalName.toLowerCase() === this.vm.vmSize.toLowerCase());
            this.$forceUpdate();
        }
    }

    gotoWorkspaceDetails(){    
        this.$emit('GoToEdit');
    }
    async downloadRdp() {
        var token = await this.$store.state.authModule.getapiTokenPopup();
        await this.vm.getRdp(this.$route.params.resourceGroupName, token);
    }

    formatMoney(money: number){
        return Helper.formatMoney(money);
    }

    async copyPw() {
        this.passwordIsLoading = true;
        var params = this.$route.params;
        var token = await this.$store.state.authModule.getapiTokenPopup();
        const url =
        process.env.VUE_APP_ROOT_API +
        `Workspace/${params.resourceGroupName}/subscription/${params.subscriptionId}/secret/${this.vm.name}`;
        var secret = await ajaxGet(url, token);

        if (secret !== null) {
        this.$swal({
            html: `Your password is: <span class="pwsecret">${secret}</span>`,
        });
        }
        this.passwordIsLoading = false;
    }

    private async openModalRemoveVM(){
        var answer = await this.$swal({
        title:
            `You are about to remove this Virtual Machine with all its data. There is no backup. Are you sure?`,
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowOutsideClick: true
        });
        if(answer.value){
            var params = this.$route.params;
            var token = await this.$store.state.authModule.getapiTokenPopup();
            var vm = new VirtualMachine(this.vm);
            vm.remove(params.resourceGroupName, params.subscriptionId, token);
            this.updateVmState(vm, "Deleting");
            this.$emit("vmRemoved", this.vm.name);
        } else {
            return;
        }
    }

    private async openModalStopVM(){
        var answer = await this.$swal({
        title:
            `You are about to stop this Virtual Machine. Are you sure?`,
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowOutsideClick: true
        });
        if(answer.value){
            this.updateVm();
        } else {
            return;
        }
    }

    private updateVmState(vm: VirtualMachine, state: string) {
      vm.updateState(state);
      this.$emit("updateVm");
      this.log("emitted updateVm")
    }

    async updateVm() {
        var vm = this.vm;
        this.log("(updateVm...)");
        var token = await this.$store.state.authModule.getapiTokenPopup();
        var params = new WorkspaceDetailsParams(this.$route.params);
        if (vm.powerState === "VM deallocated") {
            if (vm.currentSizeAndPrice) {
              var allocatedPrice = vm.currentSizeAndPrice.pricePerHour * 24;
              var futureCostPerDay = this.currentWorkspaceCostPerDay + allocatedPrice;
              var budgetleft = this.budget.amount * 0.95 - this.budget.currentSpend;
              var daysRemaining = budgetleft / futureCostPerDay;
              if (daysRemaining < 1) {
                var answer = await this.$swal({
                  title:
                      `Your budget is insufficient to start this machine because the budget will be spent in less than 1 day.`,
                  showCancelButton: true,
                  showConfirmButton: false,
                  cancelButtonText: "Ok",
                  allowOutsideClick: true
                });
                return;
              }
            }
            this.updateVmState(vm, "VM starting");
            var result = await vm.updateVm(
                this.$route.params.resourceGroupName,
                this.$route.params.subscriptionId,
                "Start",
                token
            );
            if (result !== null) {
                this.updateVmState(vm, "VM running");
            } else {
                this.updateVmState(vm, "VM deallocated");
            }
        } else if (vm.powerState === "VM running"  || vm.powerState === "") {
            this.updateVmState(vm, "VM deallocating");
            var result = await vm.updateVm(
                this.$route.params.resourceGroupName,
                this.$route.params.subscriptionId,
                "Stop",
                token
            );
            if (result !== null) {
              this.updateVmState(vm, "VM deallocated");
            } else {
              this.updateVmState(vm, "VM running");
            }
        }

        var vmUrl = process.env.VUE_APP_ROOT_API + `Workspace/${params.resourceGroupName}/subscription/${params.subscriptionId}/virtualMachine/${vm.name}/sizetypes/${vm.powerState === "VM deallocated"}`;
        var result = await ajaxGet(vmUrl, token);
        result.forEach((element: SizeAndPrice) => {
            element.pricePerHour = element.pricePerMonthInEuro/729.77;
          }); 
        vm.sizes = result;
        this.log("(...updateVm)");
        this.vm = vm;
  }

    showChangeOptions() {
        this.vm.changingSize = !this.vm.changingSize;
    }

    private async restartModal(){
        var answer = await this.$swal({
        title:
            "For this change, the VM needs to be stopped. Do you want to proceed?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowOutsideClick: true
        });
        if(answer.value) {
            return true;
        }
        else{
            return false;
        }
    }

    async changeSize() {
        var vm = this.vm;
        var continueScaling = await this.checkFutureDaysRemaining();
        if (!continueScaling) return;
        if(vm.powerState != "VM deallocated" || !continueScaling) {
            continueScaling = await this.restartModal();
        }
        if(!continueScaling) return;
        this.updateVmState(vm, "Resizing");
        vm.changingSize = true;
        var oldVmSize = this.vm.vmSize;
        this.vm.vmSize = this.selectedSizeAndPrice.technicalName;
        this.showResizeInfo = false;
        var token = await this.$store.state.authModule.getapiTokenPopup();
        var result = await vm.scaleVirtualMachine(
            this.$route.params.resourceGroupName,
            this.$route.params.subscriptionId,
            token
        );
        if (result !== null) {
            vm.powerState = result;
            vm.currentSizeAndPrice = vm.sizes.find(
                (s: SizeAndPrice) => s.technicalName === vm.vmSize
            );
            this.vm.setBackgroundColor();
            vm.changingSize = false;
        }
        else {
            this.updateVmState(vm, "VM deallocated");
            this.vm.vmSize = oldVmSize;
        }
        this.vm = vm;
    }

    async checkFutureDaysRemaining(): Promise<boolean> {
        if(!this.selectedSizeAndPrice){
            var answer = await this.$swal({
            title:
                `Please select a size`,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Ok",
            allowOutsideClick: true
        });
        }
        if(this.futureDaysOfBudgetRemaining > 5){
            return true;
        } else if (this.futureDaysOfBudgetRemaining > 1){
            var answer = await this.$swal({
                title:
                    `Are you sure you want to add this VM or scale to this size? With this vm/size the budget will be spent in ${Math.floor(this.futureDaysOfBudgetRemaining)} days`,
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                allowOutsideClick: true
            });
            if(answer.value){
                return true
            } 
            return false;
        }
        var answer = await this.$swal({
            title:
                `Your budget is insufficient to add this VM or scale to this size because the budget will be spent in less than 1 day.`,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Ok",
            allowOutsideClick: true
        });
        return false;
    }

    onRowSelected(sizeAndPrice: SizeAndPrice, futureDaysOfBudgetRemaining: number){
        this.selectedSizeAndPrice = sizeAndPrice;
        this.futureDaysOfBudgetRemaining = futureDaysOfBudgetRemaining;
    }
}

